import { Modal, Select, DatePicker, message, Button } from "antd";
import withDashboardLayout from "../../hoc/withDashboardLayout";
import { useEffect, useRef, useState } from "react";
import DeleteIcon from "../../assets/delete-icon.png";
import MaterialTable from "material-table";
import tableIcons from "../../utils/tableIcons";
import {
  CaretDownOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { DeleteSearchListItem, GetSearchList } from "../../utils/api";
// import Loader from "../../components/shared/Loader";

const overlayContainer = {
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const SearchList = () => {
  const tableRef = useRef(null);
  const [modalData, setModalData] = useState({
    visible: false,
    item: null,
    action: null,
  });
  const [query, setQuery] = useState({
    page: 0,
    pageSize: 25,
    search: "",
    orderField: "",
    orderDirection: "",
    customFilter: "",
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { RangePicker } = DatePicker;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSelectChange = (option) => {
    if (option !== "") {
      setStartDate(null);
      setEndDate(null);
    }
    setQuery((prev) => ({
      ...prev,
      customFilter: option,
      page: 0,
      pageSize: 25,
    }));
  };

  const onRangeChange = (dates) => {
    if (dates === null) {
      setEndDate(null);
      setStartDate(null);
      tableRef.current.onQueryChange();
    }
    if (dates && dates.length === 2) {
      const startDate = dates[0].format("YYYY-MM-DD");
      const endDate = dates[1].format("YYYY-MM-DD");
      if (startDate) {
        setStartDate(startDate);
      }
      if (endDate) {
        setEndDate(endDate);
      }
      tableRef.current.onQueryChange(null);
    }
  };

  const columns = [
    {
      title: "Id",
      field: "id",
      sorting: true,
      cellStyle: { width: "24%" },
    },
    {
      title: "Search Keywords",
      field: "searchedKeyword",
      cellStyle: { width: "24%" },
      sorting: true,
    },
    {
      title: "Client Username",
      field: "clientUserName",
      cellStyle: { width: "24%" },
      sorting: true,
    },
    {
      title: "Date & Time",
      field: "createdAt",
      cellStyle: { width: "24%" },
      sorting: true,
      render: (record) => {
        return (
          <span>{dayjs(record?.createdAt).format("DD/MM/YYYY, h:mm a")}</span>
        );
      },
    },
    {
      title: "Action",
      cellStyle: { width: "4%" },
      sorting: false,
      align: "center",
      render: (record) => {
        return (
          <div
            className="cursor-pointer flex items-center ml-2 2xl:ml-3"
            onClick={() => handleActionModalOpen("delete", record)}
          >
            <img className="w-5 h-5" src={DeleteIcon} alt="delete-icon" />
          </div>
        );
      },
    },
  ];

  const fetchData = async (dataquery) => {
    setLoading(true);

    let params = "";

    if (dataquery?.search) {
      params += `search=${dataquery.search}`;
    }

    if (dataquery?.orderBy) {
      if (dataquery?.orderBy.field === "createdAt") {
        params += `&sort=created_at&order=${dataquery?.orderDirection}`;
      } else {
        params += `&sort=${dataquery?.orderBy.field}&order=${dataquery?.orderDirection}`;
      }
    }

    params += `&pageNo=${dataquery?.page + 1}`;

    params += `&limit=${dataquery?.pageSize}`;

    if (query.customFilter === "") {
      if (startDate && endDate) {
        params += `&filter=custom`;
        params += `&startDate=${startDate}`;
        params += `&endDate=${endDate}`;
      } else {
        params += `&filter=`;
      }
    } else {
      params += `&filter=${query.customFilter}`;
    }

    const response = await GetSearchList(params);

    setLoading(false);

    return {
      data: response?.items,
      page: dataquery?.page,
      totalCount: response?.totalRecords,
    };
  };

  const handleActionModalOpen = (action, item) => {
    if (action === "delete") {
      setModalData({ visible: true, item: item, action: action });
    }
  };

  const handleModalCancel = () => {
    setModalData({ visible: false, item: null });
  };

  const handleDeleteOk = async () => {
    if (modalData.action === "delete") {
      try {
        setBtnLoading(true);
        const res = await DeleteSearchListItem(
          { statusType: "deleted" },
          modalData?.item?.id
        );
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success("Search item Deleted successfully");
          setModalData({ visible: false, item: null, action: null });
          tableRef.current.onQueryChange();
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in deletion, Try again later");
      }
    }
  };

  useEffect(() => {
    tableRef.current.onQueryChange(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.customFilter, startDate, endDate]);

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        {/* Search List Header */}
        <div className="w-full py-4">
          <h2 className="font-semibold text-lg title text-[#000000]">
            Search List
          </h2>
        </div>

        {/* Search List */}
        <div className="search-custom-space main-scroll w-full min-h-[calc(100vh-170px)] h-[380px] overflow-scroll flex flex-col gap-y-5 box-shadow rounded-2xl relative">
          <div className="absolute flex items-center justify-end gap-x-2 z-50 right-4 top-5">
            {query.customFilter === "" && (
              <div>
                <RangePicker
                  value={[
                    startDate ? dayjs(startDate) : null,
                    endDate ? dayjs(endDate) : null,
                  ]}
                  onChange={onRangeChange}
                  format="D MMM YY"
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
            )}
            <Select
              suffixIcon={<CaretDownOutlined />}
              className={`w-32 ${loading && "opacity-50"}`}
              value={query.customFilter}
              onChange={handleSelectChange}
            >
              <Select.Option value="today">Today</Select.Option>
              <Select.Option value="thisWeek">This Week</Select.Option>
              <Select.Option value="lastMonth">Last Month</Select.Option>
              <Select.Option value="quarter">This Quarter</Select.Option>
              <Select.Option value="thisYear">This Year</Select.Option>
              <Select.Option value="">Custom</Select.Option>
            </Select>
          </div>

          {/* <div className='flex items-center justify-between gap-x-3 px-5'> */}
          {/* <div className='w-max border rounded-md p-0.5 border-[#EBEBEB] '>
                            <Search placeholder="Searching..." onSearch={() => { }} enterButton className="w-[300px] h-full " />
                        </div>
                        <Select
                            defaultValue="This Month"
                            className='w-40'
                            onChange={handleSelectChange}
                            options={[
                                {
                                    value: 'thismonth',
                                    label: 'This Month',
                                },
                                {
                                    value: 'thisyear',
                                    label: 'This Year',
                                },
                                {
                                    value: 'lastmonth',
                                    label: 'Last Month',
                                },
                                {
                                    value: 'lastyear',
                                    label: 'Last Month',
                                },
                            ]}
                        />
                    </div> */}

          {/* <Table className='border-top' columns={columns} dataSource={dataSource} pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5', '10', '15', '20'] }} onChange={onChange} /> */}

          <MaterialTable
            tableRef={tableRef}
            title="Searchlist"
            columns={columns}
            icons={tableIcons}
            page={query.page}
            options={{
              showTitle: false,
              draggable: false,
              paging: true,
              pageSize: Number(query.pageSize),
              pageSizeOptions: [10, 25, 50, 100],
              debounceInterval: 700,
              padding: "dense",
              paginationType: "stepped",
              searchFieldVariant: "outlined",
              searchFieldAlignment: "left",
            }}
            onChangeRowsPerPage={(pageSize) => {
              setQuery((prev) => ({ ...prev, pageSize: Number(pageSize) }));
            }}
            onChangePage={(page) =>
              setQuery((prev) => ({ ...prev, page: Number(page) }))
            }
            data={(query) => fetchData(query)}
            components={{
              Pagination: (props) => {
                const {
                  page,
                  rowsPerPage,
                  count,
                  onChangePage,
                  onChangeRowsPerPage,
                } = props;
                return (
                  <div
                    className="box-shadow-pagination text-sm"
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px 20px",
                      marginTop: "20px",
                    }}
                  >
                    <div>
                      <div className="bottom-pagination-text">
                        <button
                          className="disabled:opacity-50"
                          onClick={(e) => onChangePage(e, page - 1)}
                          disabled={page === 0}
                        >
                          <LeftOutlined />
                        </button>
                        <span style={{ margin: "0 10px" }}>
                          {page + 1} of {Math.ceil(count / rowsPerPage)}
                        </span>
                        <button
                          className="disabled:opacity-50"
                          onClick={(e) => onChangePage(e, page + 1)}
                          disabled={
                            page === Math.ceil(count / rowsPerPage) - 1 ||
                            tableRef.current?.dataManager?.data?.length === 0
                          }
                        >
                          <RightOutlined />
                        </button>
                      </div>
                    </div>
                    <div style={{ position: "absolute", right: "25px" }}>
                      <span style={{ margin: "0 10px" }}>Items per page:</span>
                      <select
                        className="pagination-select"
                        value={rowsPerPage}
                        disabled={
                          tableRef.current?.dataManager?.data?.length === 0
                        }
                        onChange={(e) => {
                          onChangeRowsPerPage(e, e.target.value);
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>
                );
              },
              OverlayLoading: (props) => {
                return <div style={overlayContainer}>{/* <Loader /> */}</div>;
              },
            }}
          />
          <Modal
            centered
            title="Confirm Deletion"
            open={modalData.visible}
            onCancel={handleModalCancel}
            footer={
              <div>
                <Button onClick={handleModalCancel}>Cancel</Button>
                <Button
                  type="primary"
                  className="text-white"
                  onClick={
                    modalData.action === "delete" ? handleDeleteOk : null
                  }
                >
                  Ok
                  {btnLoading && (
                    <span className="loader ml-2 align-middle mb-1"></span>
                  )}
                </Button>
              </div>
            }
          >
            {`Are you sure you want to delete this item?`}
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default withDashboardLayout(SearchList);
